import instance from "../../../API/MainAPI";

export function GameProposalOverviewAPI() {
  return instance.get("/v1/labs/game-proposals");
}

export function GameProposalDetailsAPI(gameProposalId: number) {
  return instance.get(`/v1/labs/game-proposals/${gameProposalId}`);
}

export function GameProposalProjectInfoDetailsAPI(gameProposalId: number) {
  return instance.get(`/v1/labs/game-proposals/${gameProposalId}/project-info`);
}

export function GameProposalProjectInfoSaveApi(gameProposalId: number, data: FormData) {
  return instance.post(`/v1/labs/game-proposals/${gameProposalId}/project-info`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
  );
}

export function LabsQuestionOverviewAPI(gameProposalId: number) {
  return instance.get(`/v1/labs/game-proposals/${gameProposalId}/questions`);
}

export function QuestionsBySourceAPI(source: string, genre?: string) {
  const url = genre
    ? `/v1/questions/source?source=${source}&genre=${genre}`
    : `/v1/questions/source?source=${source}`;

  return instance.get(url);
}

export function LabsQuestionComposeAPI(gameProposalId: number, data: any) {
  return instance.post(`/v1/labs/game-proposals/${gameProposalId}/questions`, data);
}

export function GameProposalEstimateAPI(gameProposalId: number) {
  return instance.get(`/v1/labs/game-proposals/${gameProposalId}/estimate`);
}

export function LabsGameProposalSubmitAPI(gameProposalId: number, data: any) {
  return instance.post(`/v1/labs/game-proposals/${gameProposalId}/submissions`, data);
}

export function QuestionDetailAPI(questionId: number) {
  return instance.get(`/v1/questions/${questionId}`);
}

export function LabsGameTestPlanDetailsAPI(gameId: number) {
  return instance.get(`/v1/labs/games/${gameId}/test-plan`);
}

export function LabsGameStartTestAPI(gameProposalId: number) {
  return instance.get(`/v1/labs/game-proposals/${gameProposalId}/start-test`);
}

export function LabsGameProposalStartTestAPI(gameProposalId: number) {
  return instance.post(`/v1/labs/game-proposals/${gameProposalId}/start-test`);
}

export function LabsGameProposalPreviewAPI(gameProposalId: number) {
  return instance.get(`/v1/labs/game-proposals/${gameProposalId}/preview`);
}

export function LabsGameProposalProjectInfoAPI(gameProposalId: number) {
  return instance.get(`/v1/labs/game-proposals/${gameProposalId}/project-info`);
}

export function LabsGameProposalTestPlanDetailsAPI(gameProposalId: number) {
  return instance.get(`/v1/labs/game-proposals/${gameProposalId}/test-plan`);
}

export function LabsGameQuestionListAPI(gameId: number) {
  return instance.get(`/v1/labs/games/${gameId}/questions`);
}

/*
  연구소 게임 상세 조회 API 
  https://dev.plithus.com/docs/newIndex.html#labs_game_details_api
*/
export function LabsGameDetailsAPI(gameId: number) {
  return instance.get(`/v1/labs/games/${gameId}`);
}

/*
  연구소 게임 수정 API
  https://dev.plithus.com/docs/newIndex.html#labs_game_modification_api
*/
export function LabsGameModificationAPI(gameId: number, data: FormData) {
  return instance.post(`/v1/labs/games/${gameId}`, data
  );
}

export function LabsGameProposalProjectInfoApprovedModificationAPI(gameProposalId: number, data: any) {
  return instance.post(`/v1/labs/game-proposals/${gameProposalId}/project-info/approved`, data
  );
}

// 지갑 데이터 인터페이스 수정
export interface PendingRecharge {
  id: number;
  createdAt: string;
  ordererName: string;
  orderAmount: number;
  status: string;
  taxInvoiceRequested: boolean;
}


export interface WalletDataPage {
  content: PendingRecharge[];
  pageable: {
    pageNumber: number;
    pageSize: number;
    totalElements: number;
    totalPages: number;
    first: boolean;
    last: boolean;
  };
}

export interface WalletRechargeDataResponse {
  count: number;
  page: WalletDataPage;
}

/*
https://dev.plithus.com/docs/newIndex.html#labs_wallet_overview_api
*/

export function LabsWalletRechargePagesAPI(pageNumber = 0, pageSize = 10) {
  return instance.get(`/v1/labs/wallets?pageNumber=${pageNumber}&pageSize=${pageSize}`);
}


export function LabsWalletTransactionPagesAPI(pageNumber = 0, pageSize = 10) {
  return instance.get(`/v1/labs/wallets/transactions?pageNumber=${pageNumber}&pageSize=${pageSize}`);
}

